$(function () {
    const tabs = $('[data-disruption-tab]');
    const panels = $('[data-disruption-panel]');

    if (!tabs.length || !panels.length) {
        return;
    }

    function activateTab(slug, shouldFocus) {
        const targetTab = tabs.filter('[data-disruption-tab="' + slug + '"]').first();
        const targetPanel = panels.filter('[data-disruption-panel="' + slug + '"]').first();

        if (!targetTab.length || !targetPanel.length) {
            return;
        }

        tabs.each(function () {
            const tab = $(this);
            const isActive = tab.is(targetTab);

            tab.toggleClass('is-active', isActive);
            tab.attr('aria-selected', isActive ? 'true' : 'false');
            tab.attr('tabindex', isActive ? '0' : '-1');
        });

        panels.each(function () {
            const panel = $(this);
            const isActive = panel.is(targetPanel);

            panel.toggleClass('is-active', isActive);
            panel.prop('hidden', !isActive);
        });

        if (shouldFocus) {
            targetTab.trigger('focus');
        }
    }

    tabs.on('click', function () {
        activateTab($(this).data('disruption-tab'), false);
    });

    tabs.on('keydown', function (event) {
        const currentIndex = tabs.index(this);
        let nextIndex;

        if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
            nextIndex = 0;
        } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
        } else {
            return;
        }

        event.preventDefault();
        activateTab($(tabs.get(nextIndex)).data('disruption-tab'), true);
    });

    let initialTab = tabs.filter('[aria-selected="true"]').first();

    if (!initialTab.length) {
        initialTab = tabs.first();
    }

    activateTab(initialTab.data('disruption-tab'), false);
});
